/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailVerificationResponse } from '../../models/email-verification-response';

export interface SendEmailVerification$Params {
}

export function sendEmailVerification(http: HttpClient, rootUrl: string, params?: SendEmailVerification$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailVerificationResponse>> {
  const rb = new RequestBuilder(rootUrl, sendEmailVerification.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmailVerificationResponse>;
    })
  );
}

sendEmailVerification.PATH = '/rest/email-verification';
